import React from 'react';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import IconButton from '@material-ui/core/IconButton';
//import Badge from '@material-ui/core/Badge';
//import MailIcon from '@material-ui/icons/Mail';
import ContactSupportIcon from '@material-ui/icons/ContactSupport';
//import StyleIcon from '@material-ui/icons/Style';
import DataUsageIcon from '@material-ui/icons/DataUsage';

import {Styles} from './Styles';
//import Ajax from './Ajax';

interface Props {
    top():void,
    guide?():void,
}

const Header = (props:Props)=> {
    //Ajax.setUserId(props.userId);
    const classes = Styles.base();

	return (
        <AppBar position="absolute" className={classes.AppBar}>
            <Toolbar variant="dense" className={classes.Toolbar}>
                <div><Tooltip title="TOP"><span className={classes.withIcon+" "+classes.clickable} onClick={props.top}><DataUsageIcon style={{marginRight:"0.25em"}}/>Apart</span></Tooltip></div>
                <div className={classes.grow} style={{textAlign:"right"}}>
                {props.guide &&
                <Tooltip title="説明"><IconButton aria-label="config" color="inherit" onClick={props.guide}>
                <ContactSupportIcon style={{color:"white"}}/>
                </IconButton></Tooltip>
                }
                </div>
            </Toolbar>
        </AppBar>
	);
}

export default Header;
